import {createSelector} from '@reduxjs/toolkit';

import {getUserIdFromChannelName} from 'mattermost-redux/utils/channel_utils';

import {isDirectChannel} from 'utils/isDirectChannel';

import {getAllChannels} from './channels';
import {getCurrentUserId} from './common';

export const getDmUsers = createSelector(getAllChannels, getCurrentUserId, (channels, currentUserId) => {
    return Object.values(channels).reduce((acc, channel) => {
        if (!isDirectChannel(channel)) {
            return acc;
        }

        if (isDirectChannel(channel)) {
            const teammateId = getUserIdFromChannelName(currentUserId, channel.name);
            acc.push(teammateId);
        }

        return acc;
    }, [] as string[]);
});
